<template>
  <div class="ui-wrap">
    <div class="ui-box">
      <p class="title">{{$t("account")}}</p>
      <div class="content">
        <p class="topic">{{$t("balance")}}</p>
        <p class="surplus"><span class="us-margin">US$</span>{{balance}}</p>
        <p class="topic">{{$t("choose")}}</p>
        <ul class="typelist">
          <li v-for="(item, index) in list" :key="item.id" :class="{on: tab1 === index}" @click="tab1 = index">
            <p class="price">{{$t("pay")}}<span class="us-margin">US$</span>{{item.amount}}</p>
            <p class="extra">{{$t("bonus")}}<span class="us-margin">US$</span>{{item.give}}</p>
          </li>
          <li class="other" :class="{on: tab1 === 99}" @click="tab1 = 99">
            <input type="number" v-model.number="ipt" :placeholder="$t('holder')" min="0"> 
          </li>
        </ul>
        <p class="topic">{{$t("type")}}</p>
        <ul class="typelist">
          <!-- <li class="alipay" :class="{on: tab2 === 0}" @click="tab2 = 0"></li>
          <li class="wechatpay" :class="{on: tab2 === 1}" @click="tab2 = 1"></li> -->
          <li class="paypal" :class="{on: tab2 === 'pay_pal'}" @click="tab2 = 'pay_pal'"></li>
        </ul>
        <div class="total">
          <div class="prestore">
            <p class="lab">{{$t("prev")}}</p>
            <p class="price" v-if="tab1 === 99"><span class="us-margin">US$</span>{{ipt?ipt:0}}</p>
            <p class="price" v-else><span class="us-margin">US$</span>{{list[tab1].amount}}</p>
          </div>
          <div class="truth">
            <p class="lab">{{$t("total")}}</p>
            <p class="price" v-if="tab1 === 99"><span class="us-margin">US$</span>{{ipt?ipt:0}}</p>
            <p class="price" v-else><span class="us-margin">US$</span>{{list[tab1].amount + list[tab1].give}}</p>
          </div>
        </div>
      </div>
      <div class="btns">
        <a class="ui-btn gray" href="javascript: history.go(-1);">{{$t("cancel")}}</a>
        <a class="ui-btn" @click="submit">{{$t("user.gopay")}}</a>
      </div>
    </div>
  </div>
</template>
<script>
import {rechargeSetupList, getAmount} from '@/service/api.js'
import {recharge, payOrder} from '@/service/studentApi.js'
export default {
  data(){
    return {
      tab1: 0,
      tab2: 'pay_pal',
      list: [{amount: 0, give: 0}],
      ipt: '',
      balance: 10
    }
  },
  created(){
    this.rechargeSetupList()
    this.getAmount()
  },
  methods: {
    async rechargeSetupList(){
      let res = await rechargeSetupList()
      if(res.data.status === 1){
        this.list = res.data.data
      }
    },
    async getAmount(){
      let res = await getAmount()
      if(res.data.status === 1){
        this.balance = res.data.balance
      }
    },
    async submit(){
      let obj = {channel: this.tab2}
      if(this.tab1 === 99){
        obj.amount = this.ipt
        obj.id = 999999
      }else{
        obj.id = this.list[this.tab1].id
        obj.amount=this.list[this.tab1].amount
      }
      const res = await recharge(obj)
      if(res.data.status === 1){
        this.payOrder(res.data.data)
      }
    },
    async payOrder(data){
      let res = await payOrder(data)
      if(res.data.status){
        if(res.data.status === 1){
          window.location.href = res.data.data.approveUrl
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title{padding: 42px 0 41px; text-align: center; font-size: 32px; line-height: 42px; border-bottom: 1px solid #D6D6D6;}
.content{padding: 50px 80px;}
.topic{font-size: 21px; line-height: 27px; font-weight: bold;}
.surplus{margin: 20px 0 50px; font-weight: bold; font-size: 42px; line-height: 55px;}
.typelist{
  display: flex; margin: 30px 0 50px;
  .price{font-weight: bold; font-size: 18px; color: #002147; line-height: 24px;}
  .extra{color: #999; line-height: 19px;}
  li{
    margin-right: 10px; border: 1px solid #E2E2E2; border-radius: 12px; padding: 20px 0 0; text-align: center; width: 180px; height: 82px; cursor: pointer;
    &.on{border-color: #0086ea;}
    &.other{padding-top: 25px; width: 220px;}
    &.alipay{background: url(../assets/alipay.jpg) no-repeat center center;}
    &.wechatpay{background: url(../assets/wechatpay.jpg) no-repeat center center;}
    &.paypal{background: url(../assets/paypal.jpg) no-repeat center center;}
  }
  input{
    border: 0; text-align: center; font-size: 18px; font-weight: bold; color: #002147; width: 95%;
    &::placeholder{font-size: 14px; font-weight: normal; color: #999;}
  }
}
.btns{
  padding: 70px; border-top: 1px solid #D6D6D6; text-align: center;
  .ui-btn{margin: 0 25px;}
}
.total{
  display: flex;
  .prestore{min-width: 260px; padding-right: 50px;}
  .lab{font-size: 16px; line-height: 21px;}
  .price{margin-top: 10px; font-size: 32px; line-height: 42px; font-weight: bold;}
}
.us-margin{
  margin:0 5px;
}
</style>
<i18n>
{
  "cn": {
    "account": "预存页面",
    "balance": "账户余额",
    "choose": "选择金额",
    "type": "支付方式",
    "prev": "预存金额",
    "total": "到帐金额",
    "holder": "请输入充值金额",
    "pay":"充",
    "bonus":"送"
  },
  "TW": {
    "account": "預存頁面",
    "balance": "帳戶餘額",
    "choose": "選擇金額",
    "type": "支付方式",
    "prev": "預存金額",
    "total": "到帳金額",
    "holder": "請輸入充值金額",
    "pay":"充",
    "bonus":"送"
  },
  "en": {
    "account": "Account Credit Top-up",
    "balance": "Remaining balance ",
    "choose": "Choose an amount",
    "type": "Payment method",
    "prev": "Payment amount",
    "total": "Top-up amount",
    "holder": " Enter top-up amount",
    "pay":"Pay",
    "bonus":"Bonus"
  }
}
</i18n>